export default __webpack_public_path__ + "static/media/exportReport.ad2d3d2b.svg";